<template>
  <div>
    <el-backtop></el-backtop>
    <div class="content-row" style="position: relative;">
      <el-carousel height="25rem">
        <el-carousel-item v-for="item in pages" :key="item" style="height:100%;width:100%">
          <div @click="advert(item)" style="height:100%;width:100%">
            <el-image class="recommend-img" :src="is_api + item.url" style="height:100%;width:100%"></el-image>
          </div>
        </el-carousel-item>
      </el-carousel>

      <div class="fixed_btn pointer">
        <p @click="personal()" title="个人中心">
          <el-image src="static/image/touxiang.png"></el-image>
        </p>
        <p @click="cart()" title="购物车">
          <el-image src="static/image/gouwuche.png"></el-image>
        </p>
        <p title="历史浏览" @click="table = true">
          <el-image src="static/image/lishi.png"></el-image>
        </p>
        <p @click="collection()" title="我的收藏">
          <el-image src="static/image/xin.png"></el-image>
        </p>
        <p title="购物反馈" @click="Feedback()">
          <el-image src="static/image/xinxi.png"></el-image>
        </p>
      </div>
      <el-drawer
        title="我的足迹"
        :visible.sync="table"
        direction="rtl"
        size="300px"
        class="scroll">
        <ul style="padding: 10px;">
          <li
            v-for="(item,index) in history"
            :key="index"
            @click="history_good_detail(item)"
            class="history-goods"
            style="display: inline-block;padding:5%;margin:5%"
          >
            <div class="demo-image__preview good_img">
              <el-image
                v-if="item.pic!=''&&item.pic!=null"
                :src="item.pic"
                style="height:100%;width:100%"
              ></el-image>
              <el-image v-else src="static/image/error.png" style="height:100%;width:100%"></el-image>
            </div>
            <div class>
              <span class="span-price">￥{{item.price}}</span>
              <span
                style="float:right;font-size:13px"
                class="good_name_sty"
              >{{item.stock_num}}&nbsp;&nbsp;{{item.unit_name}}</span>
            </div>
            <div class="content-left-row good_name_sty">
              <span
                :title="item.good_spec"
                style="width:90%;white-space:pre-wrap;overflow: hidden;color: #000;"
              >{{item.good_spec}}</span>
            </div>
            <div
              class="content-left-row f-14-gray hides"
              style="color: #000000;font-size:12px;margin-top:1%"
            >
              <span :title="item.good_name">{{item.good_name}}|{{item.brand_id}}</span>
            </div>
          </li>
        </ul>
      </el-drawer>
    </div>
    <div class="content-table">
      <div class="content-row">
            <el-col
              style="display: flex;background: #f6f6f6;align-items: end;justify-content:space-around;padding: 12px;border-radius: 9px;margin-top:15px"
            >
              <div style="width: 20%;">
                <el-row :gutter="20" style="display: flex;align-items: center;">
                  <el-col :span="8" :offset="2">
                    <el-image src="static/image/shop-list.png" style="border-radius: 50px;"></el-image>
                  </el-col>
                  <el-col :span="14">
                    <div
                      class="div_left"
                      v-if="show_name==1 ||login_user.custom_erpid==''"
                      style="font-size: 13px;margin-top: 4%"
                    >Hi ~ 欢迎来到旭欧轴承!</div>
                    <div class="div_left" v-else style="font-size: 13px;margin-top: 4%">
                      Hi ~
                      <div class="user_name font-12 inline-div">{{title}}</div>
                    </div>
                    <div class="div_left hides" style="font-size: 14px;margin-top: 7%;">
                        <el-link :underline="false" v-if="this.$store.state.currentUser == ''" @click="login()">登录  | </el-link>
                        <el-link :underline="false" v-if="this.$store.state.currentUser == ''" @click="regist()">注册</el-link>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div style="width:50%;text-align: center;margin-top: 10px;border-right: 1px solid #fff;border-left: 1px solid #fff;">
                <el-image src="static/image/banner1.png" ></el-image>
              </div>
              <div style="width: 25%;">
                <p class="div_left1" style="margin: 1% 7%;">
                  <span @click="notice()" class="pointer font-15 color">公告</span> /
                  <span @click="mation()" class="pointer font-15">产品资讯</span>
                </p>
                <div v-show="notice_hide">
                  <p
                    class="hide pointer"
                    v-for="(item,i) in notice_data"
                    :key="i"
                    @click="notice_detail(1,item)"
                    style="white-space: nowrap;overflow: hidden;
                    text-overflow: ellipsis;margin: 0 0 0 8%;"
                  >
                    <span v-html="item.title"></span>
                  </p>
                </div>
                <div v-show="mation_hide">
                  <p
                    style="white-space: nowrap;overflow: hidden;
                    text-overflow: ellipsis;margin: 0 0 0 8%;"
                    class="hide pointer"
                    v-for="(item,i) in mation_data"
                    :key="i"
                    @click="notice_detail(2,item)"
                  >
                    <!-- <span class="notice">资讯</span> -->
                    {{item.nous_name}}
                  </p>
                </div>
              </div>
            </el-col>
        </div>
      <div class="content-center-row">
          <div class="five_pic left-menu"
              style="margin-right:1%;float:left;height: 170px;"
              v-for="(item,index) in good_zone" :key="index"
              @click="zone_detail(item)">
                <el-image
                  v-if="item.area_img!=''&&item.area_img!=null"
                  class="recommend-img top-image width-100"
                  style="height:100%"
                  :src="item.area_img"
                ></el-image>
                <el-image
                  v-else
                  class="recommend-img top-image width-100"
                  style="height:100%"
                  src="static/image/error.png"
                ></el-image>
              </div>
      </div>
      <div class="content-center-row" style="margin-top:1.5%">
        <div class="content-center-row">
              <div class="content-center-row div-recent" style="text-align:center">
                <el-divider content-position="center">
                  <span class="prom_title_eng">HOT SALE</span>
                  <span class="prom_title_chinese">热卖推荐</span>
                </el-divider>
              </div>
        </div>
      </div>
      <div class="content-center-row" style="margin-top:1.5%;display:flex;line-height:2;">
          <div class="hot-box">
            <div class="left-menu inline-div" style="margin-right:2%;">
<!--            <div class="left-menu inline-div" style="width:40%;margin-right:2%;">-->
              <el-image :src="hot_img" class="left_img"></el-image>
            </div>
            <div class="left-menu inline-div goods-box">
              <div
                v-for="(item,index) in recently_list"
                :key="index"
                v-if="index < 10"
                @click="good_detail(item)"
                class="recent-list-div pointer"
              >
                <div class="content-center-row">
                  <div class="demo-image__preview good_img">
                    <el-image
                      v-if="item.pic!=''&&item.pic!=null"
                      :src="item.pic"
                      style="height:100%;width:100%"
                    ></el-image>
                    <el-image v-else src="static/image/error.png" style="height:100%;width:100%"></el-image>
                  </div>
                </div>
                <div class="content-left-row f-14-gray hides">
                  <span class="span-price" style="float:left">￥{{item.sale_price}}</span>
                  <span
                    style="float:right;font-size:13px"
                    class="good_name_sty"
                  >{{item.stock_num}}&nbsp;&nbsp;{{item.unit_name}}</span>
                </div>
                <div class="content-left-row good_name_sty">
                  <span
                    :title="item.good_spec"
                    style="width:90%;white-space:pre-wrap;overflow: hidden;color: #000;"
                  >{{item.good_spec}}</span>
                </div>
                <div
                  class="content-left-row f-14-gray hides"
                  style="color: #000000;font-size:12px;"
                >
                  <span :title="item.good_name">{{item.good_name}}|{{item.brand_id}}</span>
                </div>
              </div>
            </div>
          </div>
      </div>
      <div class="content-center-row" style="margin-top:1.5%;">
            <div class="content-center-row div-recent" style="text-align:center">
              <el-divider content-position="center">
                <span class="prom_title_eng">SPECIAL</span>
                <span class="prom_title_chinese">促销产品</span>
              </el-divider>
              <span class="f-16-blank small_eng">SPECIAL SALE</span>
            </div>
      </div>
      <div class="content-center-row promo_good">
        <div class="promo_good" style="width:100%">
              <div
                v-for="(item,index) in prom_list"
                :key="index"
                @click="good_detail(item)"
                class="good_div"
              >
                <span v-if="item.type_text" class="type_tags">
                  <span class="type">{{item.type_text}}</span>
                </span>
                <div class="content-center-row">
                  <div class="demo-image__preview good_img">
                    <el-image
                      v-if="item.pic!=''&&item.pic!=null"
                      :src="item.pic"
                      style="height:100%;width:100%"
                    ></el-image>
                    <el-image v-else src="static/image/error.png" style="height:100%;width:100%"></el-image>
                  </div>
                </div>
                <div
                  class="content-left-row f-14-gray hides"
                  v-if="item.type_text!='满赠'"
                  style="margin-top: 3%;"
                >
                  <span class="span-price" style="font-size: 16px;float:left">￥{{item.dis_price}}</span>
                  <span style="text-decoration: line-through;float:left">￥{{item.sale_price}}</span>
                  <span
                    style="float:right;color:#000"
                  >{{item.stock_num}}&nbsp;&nbsp;{{item.unit_name}}</span>
                </div>
                <div
                  class="content-left-row f-14-gray hides"
                  v-if="item.type_text=='满赠'"
                  style="margin-top: 3%;"
                >
                  <span class="span-price" style="font-size: 16px;float:left">￥{{item.sale_price}}</span>
                  <span
                    style="float:right;color:#000"
                  >{{item.stock_num}}&nbsp;&nbsp;{{item.unit_name}}</span>
                </div>
                <div class="content-left-row good_name_sty" >
                  <span
                    :title="item.good_spec"
                    style="width:90%;white-space:pre-wrap;overflow: hidden;color: #000;"
                  >{{item.good_spec}}</span>
                </div>
                <div
                  class="content-left-row f-14-gray hides good_name_sty"
                  style="color: #000000;font-size:12px;margin-top: 1%;"
                >
                  <span
                    :title="item.good_name"
                    style="float:left"
                  >{{item.good_name}}|{{item.brand_id}}</span>
                </div>
              </div>
              <div class="list" v-for="item in (6-(prom_list.length%6))" v-if="prom_list.length%6 > 0"></div>
        </div>
      </div>
      <div
        class="content-center-row"
        style="margin-top:1.5%;margin-bottom:1.5%"
        v-if="prom_list.length>=10">
            <div class="content-center-row div-recent" style="text-align:center">
              <el-divider content-position="center" class="pointer" @click="prom_detail">
                <span class style="color:#c39a58">>></span>
                <span class="prom_title_chinese" style="color:#c39a58">查看更多</span>
                <span class style="color:#c39a58"><<</span>
              </el-divider>
            </div>
      </div>
    </div>
    <el-dialog :visible.sync="centerDialogVisible" width="50%" center>
      <div class="content-row">
        <span class="col-2 left_sty">联系人</span>
        <el-input class="col-6" v-model="name"></el-input>
      </div>
      <div class="content-row">
        <span class="col-2 left_sty">手机号码</span>
        <el-input class="col-6" v-model="tel"></el-input>
      </div>
      <div class="content-row">
        <span class="col-2 left_sty">反馈内容</span>
        <vue-ueditor-wrap class="col-10" v-model="ueditor_content" :config="myConfig"></vue-ueditor-wrap>
      </div>
      <div class="content-row" style="text-align:center">
        <el-button type="primary" @click="sub_Feedback">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import qs from "qs";
import footer from "@/components/footer/index";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  components: { footer, VueUeditorWrap },
  data() {
    return {
      recently_list: [],
      hot_list: [],
      promotion_list: [],
      notice_data: [],
      mation_data: [],
      notice_hide: true,
      mation_hide: false,
      login_user: {
        custom_erpid: "",
        custom_name: ""
      },
      show_name: "",
      prom_list: [],
      good_zone: [],
      title: "",
      history: [],
      pages: [
        // {
        //   title: "slide3",
        //   url: "static/image/custBanner.png"
        // },
        // {
        //   title: "slide3",
        //   url: "static/image/lunbo.png"
        // }
      ],
      table: false,
      centerDialogVisible: false,
      ueditor_content: "",
      tel: "",
      hot_img: "",
      name: "",
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 150,
        // 初始容器宽度
        initialFrameWidth: "99%",
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl:  "http://t.com/tiancheng/public/UEditor/php/controller.php",//"http://35.201.165.105:8000/controller.php",
        // // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "static/UEditor/"
      }
    };
  },
  watch: {},
  mounted() {
    this.view();
  },
  methods: {
    view() {
      this.$axios({
        method: "post",
        url: "/index/customer/get_register_info"
      })
        .then(res => {
          this.title = res.data.data.invoices.title;
        })
        .catch(err => {});
      // 热卖商品
      this.$axios({
        method: "post",
        url: "/index/good/hot_goods",
        params: {
        }
      })
        .then(res => {
          this.recently_list = res.data.data.data.data;
        })
        .catch(err => {});
      // 促销商品
      this.$axios({
        method: "post",
        url: "/index/promotion/get_top_promo",
        params: {}
      })
        .then(res => {
          this.prom_list = res.data;
        })
        .catch(err => {});
      // 轮播图
      this.$axios({
        method: "post",
        url: "/index/index/advert",
        params: {}
      })
        .then(res => {
          res.data.data.data.forEach(element => {
            if (element.area == 0) {
              this.pages.push({
                url: element.img,
                good_erpid: element.good_erpid
              });
            } else {
              this.hot_img = element.img;
            }
          });
        })
        .catch(err => {});
      this.$axios({
        method: "post",
        url: "/index/catalogue/good_area",
        params: {}
      })
        .then(res => {
          this.good_zone = res.data.data;
        })
        .catch(err => {});
      // 历史浏览
      this.$axios({
        method: "post",
        url: "/index/good/good_history"
      })
        .then(res => {
          this.history = res.data.data.data;
        })
        .catch(err => {});
      // 公告
      this.$axios({
        method: "post",
        url: "/index/notice/search",
        params: {
          pagesize: 2
        }
      })
        .then(res => {
          this.notice_data = res.data.data.data.data;
        })
        .catch(err => {});
      // 资讯
      this.$axios({
        method: "post",
        url: "/index/nous/search",
        params: {
          pagesize: 2
        }
      })
        .then(res => {
          this.mation_data = res.data.data.data.data;
        })
        .catch(err => {});
      this.$axios({
        method: "post",
        url: "/index/index/check"
      })
        .then(res => {
          this.login_user = res.data.data;
          if (this.login_user == undefined) {
            this.show_name = 1;
          }
        })
        .catch(err => {});
    },

    notice_detail(status, item) {
      this.$router.push({
        path: "/Customized/index",
        query: { status: status, item: item }
      });
    },
    Feedback() {
      this.centerDialogVisible = true;
    },
    advert(row) {
      this.$router.push({
        path: "/advert/index",
        query: { id: row.good_erpid }
      });
    },
    zone_detail(item) {
      this.$router.push({
        path: "/HomePage/detail",
        query: { id: item.id }
      });
    },
    good_detail(item) {
      this.$router.push({
        path: "/GoodDetail/index",
        query: { id: item.id }
      });
    },
    history_good_detail(item) {
      this.$router.push({
        path: "/GoodDetail/index",
        query: { id: item.good_itemid }
      });
    },
    // 注册
    regist() {
      // this.$router.push();
      this.$router.push({
        path: "/Register/index"
      });
    },
    //登陆
    login() {
      this.$router.push({
        path: "/login/index"
      });
    },
    // 个人中心
    personal() {
      if (this.$store.state.currentUser == "") {
        this.$message1("当前未登录，请登录！");
        return;
      }
      this.$router.replace({
        path: "/Personal/index",
        query: { page_name: "我的订单", menu_id: 1 }
      });
    },
    // 购物车
    cart() {
      if (this.$store.state.currentUser == "") {
        this.$message1("当前未登录，请登录！");
        return;
      }
      this.$router.push({
        path: "/Cart/index"
      });
    },
    // 我的收藏
    collection() {
      if (this.$store.state.currentUser == "") {
        this.$message1("当前未登录，请登录！");
        return;
      }
      this.$router.replace({
        path: "/Personal/index",
        query: { page_name: "我的收藏", menu_id: 1 }
      });
    },

    detail() {
      this.$router.push({
        path: "/Detail/index"
      });
    },
    view_more(status) {
      if (status == 1) {
        this.$router.push({
          path: "/Customized/index"
        });
      } else {
        this.$router.push({
          path: "/Customized/index",
          query: { page: status }
        });
      }
    },
    sub_Feedback() {
      this.$axios({
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        },
        method: "post",
        url: "/index/customer/feedback_create",
        data: qs.stringify({
          tel: this.tel,
          content: this.ueditor_content,
          name: this.name
        })
      })
        .then(res => {
          this.$message1(res.data.msg);
          if (res.data.status == "ok") {
            this.centerDialogVisible = false;
          }
        })
        .catch(err => {});
    },
    prom_detail() {
      this.$router.push({
        path: "/Promotion/index"
      });
    },
    notice() {
      this.mation_hide = false;
      $(".div_left1 > span")
        .eq(1)
        .removeClass("color");
      $(".div_left1 > span")
        .eq(0)
        .addClass("color");
      this.notice_hide = true;
    },
    mation() {
      this.mation_hide = true;
      this.notice_hide = false;
      $(".div_left1 > span")
        .eq(0)
        .removeClass("color");
      $(".div_left1 > span")
        .eq(1)
        .addClass("color");
    },
    buyGood(good_id, cate_id) {
      if (good_id != "") {
        this.$router.push({
          path: "/GoodDetail/index",
          query: { id: good_id, cate_id: cate_id }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.left_sty {
  line-height: 40px;
  font-size: 16px;
  text-align: center;
}
body {
  overflow-y: auto;
}
.center-near-row {
  background-image: url("/static/image/center-bg.png");
}
.center-promotion-row {
  background-color: #f9f5f0;
}
.center-hot-row {
  background-color: #edf1f5;
}
.center-near-row,
.center-promotion-row,
.center-hot-row {
  margin-bottom: 0;
}
.span-white {
  color: #fff;
}
.recent-left-img {
  float: left;
  margin-left: 18.5%;
  width: 13%;
}
.recent-list-div {
  background-color: #fff;
  width: 17%;
  padding: 1%;
  margin-left: 0.75%;
  border: 1px solid whitesmoke;
  /*min-height: 255px;*/
  /*max-height: 270px;*/
  height: 270px;
  line-height: 2;
}
.recent-list-div:nth-child(1),.recent-list-div:nth-child(2),.recent-list-div:nth-child(3),.recent-list-div:nth-child(4){
  margin-bottom: 1%;
}
.recent-list-div:hover {
  // border: 1px solid lightgray;
  box-shadow: 0px 0px 2px 3px #f2f2f2;
}
.prom-list-div {
  border: 1px solid lightgray;
  background-color: #fff;
  float: left;
  width: 15.5%;
  height: 50%;
  margin: 0 1% 1% 1%;
  padding: 1%;
}
.recent-all-list {
  height: 100%;
  width: 50%;
  float: left;
  margin-left: 1%;
}

.div-recent {
  margin: 1% 0 1% 0;
}
.auto-fix-button {
}
.top-image {
  // margin-right: 1%;
  cursor: pointer;
}
.five_pic {
  width: 19%;
}
.content-center-row {
  text-align: left;
}
.el-divider--horizontal {
  margin: 16px 0;
}
// 右侧登陆div
.sign_big_div {
  // min-width: 210px;
  position: absolute;
  width: 11%;
  height: 250px;
  z-index: 2;
  top: 3%;
  right: 17%;
  text-align: center;
}
.div_left {
  text-align: left;
}
.div_left1{
  text-align: left;
}
.sign_div {
  background: #fff;
  padding-top: 4%;
  padding-bottom: 4%;
}
.notice {
  margin: 8px;
  border-radius: 3px;
  padding: 2px;
  border: 1px solid red;
  color: red;
  font-size: 12px;
}
.hides {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
}
.hide {
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  text-align: left;
  margin-left: 8%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.prom_title_eng {
  font-size: 18px;
  color: rgba(211, 20, 10, 1);
}
.prom_title_chinese {
  font-size: 16px;
  color: rgba(102, 102, 102, 1);
}
.small_eng {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  opacity: 0.6;
}
.color {
  color: red;
}
.line {
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
}
.fixed_btn {
  position: fixed;
  width: 3%;
  height: 250px;
  z-index: 2;
  top: 20%;
  right: 1%;
  text-align: center;
  margin: 4% 0;
  background: #000;
  opacity: 0.5;
}
.user_name {
  color: rgb(195, 154, 88);
  font-weight: 500;
}
.more {
  font-size: 13px;
  color: #0068d3;
  text-align: right;
  margin-right: 5%;
}
.history-goods {
  width: 80%;
}
.history-goods:hover {
  box-shadow: 0px 0px 2px 3px #f2f2f2;
}

.left_img{
  width: 100%;
  height: 100%;
  min-width: 240px;
}
</style>
<style lang="less" >
.el-drawer__open .el-drawer.rtl {
  overflow-y: scroll;
}
.el-drawer.rtl::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  /**/
}
.el-drawer.rtl::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
.el-drawer.rtl::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
.el-drawer.rtl::-webkit-scrollbar-thumb:hover {
  background: #c39a58;
}
.el-drawer.rtl::-webkit-scrollbar-corner {
  background: #179a16;
}
.type_tags{
  position: absolute;
  left: 0;
  top: 0;
  width: 35px;
  height: 40px;
  z-index: 99;
  background: url("../../../static/image/manzeng.png");
  background-size: 100%;
  .type{
    position: absolute;
    width: 100%;
    font-size: 13px;
    text-align: center;
    line-height: 40px;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage/index.vue